<template>
    <div class="form-group"  v-if="noWrapper">
        <select class="form-control "
               :class="[{'filterSelect2 ignoreValidation': isFilter}, 'form-control']"
               ref = 'input'
               :value="modelValue"
               :required="isRequired"
               :disabled="!!disabled"
               :readonly="isReadonly"
               :name="name"
               :id="id"
               v-bind="$attrs"
        ></select>
    </div>
    <np-responsive v-else :split="split">
        <template #label>
        <span>
            {{label}}
            <span
                  v-if="!!helpText"
                  data-bs-placement="right"
                  data-container="body"
                  data-bs-toggle="popover"
                  :title="label"
                  :data-popover-content="helpText"
                  class="np-popover helpBtn addPopover helpHeader">
                <i tabindex="-1" class="fa fa-info-circle"></i>
            </span>
        </span>
        </template>
        <template #input>
        <div class="form-group">
            <select class="form-control"
                   ref = 'input'
                   :value="modelValue"
                   :required="isRequired"
                   :disabled="!!disabled"
                   :readonly="isReadonly"
                   :name="name"
                   :id="id"
                   v-bind="$attrs"
            ></select>


        </div>
        </template>
    </np-responsive>
</template>

<script>
    import NPResponsive from './np-responsive.vue';
    // import {Multiselect} from "vue-multiselect";
    export default {
        name: 'np-select2',
        props: {
            label: {},
            value: {},
            modelValue:{},
            name: {},
            split: Number,
            check_config: {
                default: true
            },
            default_config: {
                default: false
            },
            mode: {
                type: String,
                default: function () {
                    return 'normal';
                }
            },
            required: false,
            readonly: false,
            fullWidth: false,
            viewMode: false,
            id: {},
            placeholder: '',
            noWrapper: Boolean,
            parameters: null,
            usePlaceholder:  {
                default: true
            },
            open: false,
            multi: false,
            autoselect: false,
            disabled: false,
            helpText: {
                type: String,
                default :'',
            },
            rules: {
                type: Array,
                default: function () {
                    return [];
                }
            },
        },
        components: {
            'np-responsive': NPResponsive,
        },
        data: function () {
            return {
                default_readonly: false,
                page_config_required: false
            }
        },
        methods: {
            formatSelection: function (state) {
                var vm = this;
                if(vm.mode === 'country') {
                    if (state.iso3) {
                        const country_iso = state.iso3.toLowerCase();
                        var img = '<span> <img class="flag" alt="' + country_iso + '" src="/assets/default/img/flags/' + country_iso.toLowerCase() + '.gif"/> <span> ' + state.text + '</span></span>';
                        return $(img);
                    }
                }
                if(vm.mode === 'phone') {
                    if (state.iso3) {
                        const country_iso = state.iso3.toLowerCase();
                        var img = '<span><span> ' + state.text + '<span> <img class="flag" alt="' + country_iso + '" src="/assets/default/img/flags/' + country_iso.toLowerCase() + '.gif"/> </span>';
                        return $(img);
                    }
                }
                return $('<span>'+state.text+'</span>');
            },
            formatResult: function(state) {
                var vm = this;

                if(vm.mode === 'phone') {
                    if (state.iso3) {
                        const country_iso = state.iso3.toLowerCase();
                        var img = ' <img class="flag" alt="' + country_iso + '" src="/assets/default/img/flags/' + country_iso.toLowerCase() + '.gif"/> '
                            + state.printable_name + ' <span>' + state.text + '</span>';
                        return $(img);
                    }
                }
                return this.formatSelection(state);
            },
            changeValue: function (value) {
                this.modelValue = value;
            },
            assignRules: function () {
                if(this.rules.length > 0) {
                    this.rules.forEach(rule => {
                        if(typeof rule === 'string') {
                            this.select.setAttribute(`${rule}`, '');
                        } else {
                            for (const [key, value] of Object.entries(rule)) {
                                if(typeof value === 'string') {
                                    this.select.setAttribute(`${key}`, `${value}`);
                                } else {
                                    if(value.hasOwnProperty('remove') && value.remove === true && this.select.hasAttribute(key)) {
                                        this.select.removeAttribute(key)
                                    }
                                }
                            }
                        }
                    })
                }
            },
            setRequired: function () {
                var $searchChoices = $(this.select).parent().find('.select2-choices,.select2-choice');
                if(!!this.isRequired && this.mode !== 'filter') {
                    $searchChoices.addClass('required-field')
                } else {
                    $searchChoices.removeClass('required-field')
                }
            },
            setFullWidth: function () {
                var $searchChoices = $(this.select).parent().find('.select2-choices');
                if(!!this.fullWidth) {
                    $searchChoices.addClass('full-width')
                } else {
                    $searchChoices.removeClass('full-width')
                }
            },
            setSingleParameter: function () {
                let vm = this;
                if (vm.modelValue != vm.parameters[0].id) {
                    vm.$emit('update:modelValue', vm.parameters[0].id);
                    vm.$emit('input', vm.parameters[0].id);
                }
            },

            init: function () {
                var vm = this;
               let lang_code = $('[data-language-code]').data('language-code').substring(0, 2);
               if (lang_code === 'no') {
                   lang_code = 'nb';
               }
              let selectConfig = {
                    data: vm.parameters,
                    templateSelection: vm.formatSelection,
                    templateResult: vm.formatResult,
                    multiple: vm.multi,
                    dropdownCss: {'width': 'auto'},
                    width: '100%',
                    language: lang_code
                };
                if(vm.usePlaceholder) {
                    selectConfig['placeholder'] = (vm.isFilter ? '- ' : `- ${this.lang('select')} `) + (!!vm.placeholder ? vm.placeholder + ' -' : '-');
                }
                if(vm.mode === 'filter') {

                    selectConfig['dropdownCss'] = function (data) {return {'font-size': '12px'}};
                    selectConfig['containerCss'] = function (data) {return {'font-size': '12px'}};
                }
                if(vm.mode === 'phone') {
                    selectConfig['matcher'] = function (params, data) {
                        // If there are no search terms, return all of the data
                        if ($.trim(params.term) === '') {
                            return data;
                        }
                        if (data.printable_name.toLowerCase().indexOf(params.term.toLowerCase()) > -1
                            || data.text.indexOf(params.term.toLowerCase()) > -1
                        ) {
                            var modifiedData = $.extend({}, data, true);
                            return modifiedData;
                        }
                        return null;
                    };
                }
                $(this.select).off("select2:select");
                if ($(this.select).hasClass('select2-hidden-accessible')) {
                    $(this.select).select2('destroy');
                }

                $(this.select)
                    .select2(selectConfig)
                    .val(vm.modelValue)
                    .trigger('change')
                    // emit event on change.
                    .on('select2:open', function(event) {
                        vm.$emit('open', event)

                        let $inputs = $('.select2-search__field');
                        if (!!$inputs && $inputs.length>0) {
                            for (let $input of $inputs) {
                                $input.focus();
                            }
                        }
                    })
                    .on('select2:close', function(event){
                        vm.$emit('close', event)
                    })
                    .on('select2:unselect', function(event){
                        vm.$emit('removed', event.choice)
                        vm.$emit('update:modelValue', this.value);
                        vm.$emit('input', this.value);
                    })
                    // .on('change', function (event) {
                    .on('select2:select', function (event) {
                        vm.$emit('update:modelValue', this.value);
                        vm.$emit('input', this.value);
                        // //console.log(event)
                        // if(!!this.value && !!event.added && event.added.hasOwnProperty('id')) {
                        // }
                        // if(vm.multi && !!event.removed && event.removed.hasOwnProperty('id')) {
                        //     vm.$emit('input', this.value);
                        // }
                        if(vm.multi && typeof event.added !== "undefined") {
                            vm.$emit('added', event.added);
                        }
                    });
                if(vm.multi){
                    var $parent = $(this.select).parent();
                    var $searchInput = $parent.find('.select2-input');
                    $searchInput.attr('autocomplete', 'new-password');
                    $searchInput.attr('placeholder', vm.placeholder);
                    if(vm.viewMode) {
                        var $searchField = $parent.find('.select2-search-field');
                        $searchField.addClass('displayNone');
                    }
                }
                if (vm.autoselect && vm.parameters.length == 1) {
                    this.setSingleParameter()
                }
                if(vm.fullWidth) {
                    this.setFullWidth()
                }
                if(!vm.viewMode) {
                    this.setRequired();
                }

                if(vm.open){
                    $(this.select).select2('open');
                }
            }
        },
        computed: {
            select: function() {
                return this.$refs.input;
            },
            isReadonly: function () {
                return this.check_config ? !!this.default_readonly : !!this.readonly;
            },
            isRequired: function () {
                return this.check_config ? !!this.page_config_required : !!this.required;
            },
            isFilter: function() {
                return this.mode === 'filter';
            }
        },
        mounted: function () {
           // this.$nextTick(()=> {
                this.assignRules();
                this.init();
           // })

            //
            // $searchInput.prop('autocomplete', 'false');
            // $searchInput.on('focus blur', function() {
            //     $(this).css('width', tableWidth);
            // });
        },
        watch: {
            modelValue: function (value) {
                // update value
                $(this.select).val(value).trigger('change')
            },
            multi: function(value) {

            },
            open: function (isOpen) {
                if (isOpen) {
                    $(this.select).select2('open');
                }
            },
            options: function (options) {
                // update options
                $(this.select).empty().select2({ data: options })
            },
            isRequired: function (required) {
                let vm = this;
                if (required === false){
                    //remove the has error styling
                    setTimeout(() => {
                        $(vm.select).closest('.form-group').removeClass('has-error')
                    }, 500)
                }
                this.setRequired();
            },
            parameters: function (parameters) {
                // update parameters
                this.$nextTick(()=> {
                $(this.select).empty();
                this.init();
                    }
                );
            }
        },
        unmounted: function () {
            if ($(this.$el).is("select2")) {
                $(this.$el).off().select2('destroy')
            }
        }
    }
</script>
<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->

<style scoped>
.filterSelect2 {
    border: 0 !important;
    padding: 0 !important;
}
.filterSelect2 > * {
    height: 30px !important;
}
</style>
